import "./App.css";
import { RouterProvider } from "react-router-dom";
import router from "./routes";
import { isIos, setDefPromt } from "./lib/utility";
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { getCountries } from "./redux/features/getCountriesSlice";
import { getUserProfileDetails } from "./redux/features/getUserProfile";
import PortraitModeScreen from "./common/PortraitModeScreen";

function App() {
  const dispatch = useDispatch();
  const user_id = localStorage.getItem("userId");

  useMemo(() => {
    dispatch(getUserProfileDetails(user_id));
  }, [user_id]);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDefPromt(e);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    dispatch(getCountries());

    if (isIos()) {
      document.title = "VisaLancer"; // short install name
    }

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
    };
  }, []);

  return (
    <div>
      <div className="orientation">
        <PortraitModeScreen />
      </div>
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
